define('GameDayCore/GDModel/ValueObjects/Scoreboard/Innings',['require','exports','module','../ValueObjectFactory','extant/extant','../Plays/AtBat','../../../GDUtil/dataMapping/NumberWithOrdinal'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant"),
        AtBatVO = require("../Plays/AtBat"),
        Ordinal = require("../../../GDUtil/dataMapping/NumberWithOrdinal");

	VO.create(Innings);

	function Innings($data) {
		var vo = VO.ensureVO(this, Innings),
			data = $data,
			top = parseInnings(data, "top"),
			bottom = parseInnings(data, "bottom");

		vo.inning=vo.num = data.num || "";

		vo.inningWithOrdinal = data.num ? Ordinal(data.num) : '';
		vo.numWithOrdinal = vo.inningWithOrdinal;
		vo.away_team = data.away_team || "";
		vo.home_team = data.home_team || "";
		vo.next = data.next || "";
		vo.top = top.innings;
		vo.bottom = bottom.innings;
		vo.halves = [{
			half : 'top',
			home_or_away : 'away',
			pitching : top.pitching,
			atbats : top.innings
		},{
			half : 'bottom',
			home_or_away : 'home',
			pitching : bottom.pitching,
			atbats : bottom.innings
		}];
		vo.isValid = (typeof data === "object");
	}

	function parseInnings (data,$half) {
		var innings = [],
			pitcher,
			pitching,
			num=1,
			ab;

		if (typeof data[$half] === "object") {

			if (exists(data[$half]._childList)) {

				for (var i = 0, len = data[$half]._childList.length; i < len; i++) {
					var atBat = data[$half]._childList.get(i);
					ab = new AtBatVO(atBat, data.num);
					//if it's an atbat, store mugs within the half inning
                    if(ab.type==="atbat" || ab.type==="action"){
                        if(ab.type==="atbat"){
                            pitcher=pitcher||atBat.pitcher;
                            num++;
                        }else if(num===1 && !pitching && atBat.event.toLowerCase().indexOf('pitching')!==-1){
                            pitching=true;
                        }
                    }
					innings.push(ab);
				}
			}
		}


		return {
			pitching : pitching || !pitcher ? false : {
				pitcher : pitcher
			},
			innings : innings
		}
	}

	return Innings;
});
